import { render, staticRenderFns } from "./Basket.vue?vue&type=template&id=589d0501"
import script from "./Basket.vue?vue&type=script&lang=js"
export * from "./Basket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports